export var BOX_CLASS_PREFIX = 'Box';